function buttonMediumPresenter(optionalText) {
	var buttonPresenter = require('./buttonPresenter')(optionalText);
	buttonPresenter.addClass('btn-sm');
	return buttonPresenter;
}

module.exports = buttonMediumPresenter;